import { Link } from 'react-router-dom';
import { Facebook, Instagram, MapPin, Phone, Mail, Star, CreditCard } from 'lucide-react';
import { COMPANY, NAV_LINKS } from '../mock/data';
import { CITIES } from '../data/locations';

const REVIEW_URL =
  process.env.REACT_APP_GOOGLE_REVIEW_URL ||
  'https://www.google.com/search?q=Better+Fence+and+Deck+Shreveport+LA&hl=en';
const CLIENT_HUB_URL = process.env.REACT_APP_JOBBER_CLIENT_HUB_URL || '';

export default function Footer() {
  return (
    <footer className="bg-ink text-cream/75 pt-16 pb-8 border-t border-white/8">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-md bg-gold flex items-center justify-center text-ink font-display text-2xl font-bold">B</div>
            <div>
              <div className="font-display uppercase text-cream text-xl tracking-wide">Better Fence &amp; Deck</div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-gold">Shreveport, Louisiana</div>
            </div>
          </div>
          <p className="mt-5 max-w-md text-sm leading-relaxed text-cream/60">
            Shreveport&rsquo;s trusted fence contractor. Expert installation for homes and businesses across the ArkLaTex &mdash; wood, vinyl, chain-link, iron, and custom decks.
          </p>
          <div className="mt-5 space-y-2 text-sm">
            <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-gold" /> <a href={`tel:${COMPANY.phoneRaw}`} className="hover:text-gold">{COMPANY.phone}</a></div>
            <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-gold" /> <a href={`mailto:${COMPANY.email}`} className="hover:text-gold">{COMPANY.email}</a></div>
            <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-gold" /> {COMPANY.address}</div>
          </div>
          <div className="mt-5 flex gap-2">
            <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full border border-white/15 hover:bg-gold hover:text-ink hover:border-gold flex items-center justify-center transition-colors"><Facebook className="w-4 h-4" /></a>
            <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full border border-white/15 hover:bg-gold hover:text-ink hover:border-gold flex items-center justify-center transition-colors"><Instagram className="w-4 h-4" /></a>
          </div>
          <a
            href={REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-review-btn"
            className="mt-5 inline-flex items-center gap-2 rounded-md bg-gold text-ink px-4 py-2.5 font-bold uppercase tracking-wider text-xs shadow-md hover:bg-gold-light transition-colors"
          >
            <Star className="w-3.5 h-3.5 fill-ink" />
            Review us on Google
          </a>
          {CLIENT_HUB_URL && (
            <a
              href={CLIENT_HUB_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-pay-invoice-btn"
              className="mt-3 ml-0 sm:ml-2 inline-flex items-center gap-2 rounded-md border border-white/20 text-cream px-4 py-2.5 font-bold uppercase tracking-wider text-xs hover:border-gold hover:text-gold transition-colors"
            >
              <CreditCard className="w-3.5 h-3.5" />
              Pay Your Invoice
            </a>
          )}
        </div>

        <div>
          <div className="text-cream font-display uppercase text-lg tracking-wide">Explore</div>
          <ul className="mt-4 space-y-2 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                {l.href.startsWith('/') ? (
                  <Link to={l.href} className="hover:text-gold transition-colors">{l.label}</Link>
                ) : (
                  <a href={l.href} className="hover:text-gold transition-colors">{l.label}</a>
                )}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-cream font-display uppercase text-lg tracking-wide">Service Area</div>
          <ul className="mt-4 grid grid-cols-1 gap-y-1.5 text-sm">
            {CITIES.map((c) => (
              <li key={c.slug}>
                <Link to={`/fence-contractor/${c.slug}`} className="text-cream/60 hover:text-gold transition-colors">
                  {c.name}, {c.state}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 mt-12 pt-6 border-t border-white/8 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-cream/40">
        <div>&copy; {new Date().getFullYear()} Better Fence &amp; Deck. All rights reserved.</div>
        <div className="flex gap-5">
          <Link to="/blog" className="hover:text-gold">Blog</Link>
          <a href="#" className="hover:text-gold">Privacy</a>
          <a href="#" className="hover:text-gold">Terms</a>
        </div>
      </div>
    </footer>
  );
}
